import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../util/assets';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  onDismiss: PropTypes.func,
};

const PhotoSearchCheckoutSuccess = ({
  title = `Congrats on becoming a Waldo Member!`,
  content,
  onDismiss,
}) => {
  return (
    <div className="photo-search-checkout-success-wrapper">
      {onDismiss && (
        <Button
          btnStyle="link"
          btnSize="lg"
          className="photo-search-checkout-success-close"
          onClick={onDismiss}
        >
          <img src={getAsset('/close-btn.svg')} alt="Close" />
        </Button>
      )}
      <div className="d-flex mb-2">
        <img
          src={getAsset('/waldo-excited.png')}
          alt="Waldo logo"
          className="photo-search-checkout-success-logo"
          width="60"
        />
      </div>
      <h3 className="photo-search-checkout-success-title">{title}</h3>

      {content}

      <p className="purchase-success-app-subtitle">
        Don&rsquo;t have the Waldo App? Download Now!
      </p>

      <div className="purchase-success-app-qr mt-0">
        <img src={getAsset('/app-download-qr-code.png')} alt="Waldo App" />
      </div>

      <img
        src={getAsset('/confetti-transparent.png')}
        alt="Confetti"
        className="photo-search-checkout-success-confetti"
      />
    </div>
  );
};

export { PhotoSearchCheckoutSuccess as PhotoSearchCheckoutSuccessComponent };

PhotoSearchCheckoutSuccess.propTypes = propTypes;

export default PhotoSearchCheckoutSuccess;
